export const KEY_AUTH = "x-auth-v1";
export const KEY_AUTH_DETAILS = "x-auth-details-v1";
export const KEY_LANG = "x-dte-lang-v1";
export const KEY_BILLINGCITY = "x-dte-billing-city-v1";
export const KEY_STORE_ID = "x-dte-store-id-v1";
export const TOTALATTEMPTS = 4;